import { placeholderSmallImgFixture } from '@fixtures/media'

export const authenticationTemplateUIFixture = {
  bgImage: placeholderSmallImgFixture
}
